import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function WbtcIcon({
  width = 50,
  height = 50,
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 30 30" width={width} height={height} {...props}>
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <g clipPath="url(#prefix__clip0_4541_87786)">
        <path
          d="M22.57 8.037l-.66.659a9.329 9.329 0 010 12.59l.66.66a10.271 10.271 0 000-13.925v.016zM8.71 8.094a9.329 9.329 0 0112.59 0l.66-.66a10.271 10.271 0 00-13.925 0l.675.66zM8.093 21.293a9.329 9.329 0 010-12.584l-.659-.659a10.271 10.271 0 000 13.924l.66-.68zM21.293 21.902a9.329 9.329 0 01-12.591 0l-.659.659a10.271 10.271 0 0013.924 0l-.674-.66z"
          fill="#5A5564"
        />
        <path
          d="M19.159 12.801c-.132-1.375-1.318-1.836-2.819-1.977V8.931h-1.16v1.858h-.926V8.931h-1.151v1.906H10.75v1.242s.857-.016.844 0a.6.6 0 01.659.51v5.218a.407.407 0 01-.141.284.4.4 0 01-.299.1c.015.014-.843 0-.843 0l-.22 1.387h2.33v1.937h1.16v-1.909h.927v1.9h1.162v-1.915c1.96-.119 3.326-.602 3.497-2.436.139-1.476-.555-2.135-1.665-2.401.675-.332 1.092-.947.998-1.953zm-1.626 4.125c0 1.441-2.469 1.277-3.255 1.277v-2.557c.786.002 3.255-.224 3.255 1.28zm-.538-3.602c0 1.318-2.06 1.158-2.715 1.158v-2.324c.655 0 2.715-.207 2.715 1.166z"
          fill="#F09242"
        />
        <path
          d="M14.998 27a12 12 0 11.005-24.001A12 12 0 0114.998 27zm0-23.064a11.058 11.058 0 10.017 22.115 11.058 11.058 0 00-.017-22.115z"
          fill="#282138"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_4541_87786">
          <path fill="#fff" transform="translate(3 3)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoWbtcIcon = React.memo(WbtcIcon);
export default MemoWbtcIcon;
